// Tiny module-level pub/sub for toast notifications. Any component calls
// showToast('message', { tone: 'success' | 'warn' | 'error' }); the
// <Toast/> mounted at the app root subscribes and renders the latest one.
// No context, no provider, no prop drilling — just import where needed.

let listeners = [];

export function showToast(message, options = {}) {
  const toast = {
    id: Date.now() + Math.random(),
    message,
    tone: options.tone || 'success',
    durationMs: options.durationMs || 3000,
  };
  listeners.forEach((cb) => {
    try { cb(toast); } catch { /* ignore listener errors */ }
  });
  return toast.id;
}

export function subscribeToToasts(cb) {
  listeners.push(cb);
  return () => { listeners = listeners.filter((l) => l !== cb); };
}

// Reset hook for tests.
export function _resetToastListenersForTests() {
  listeners = [];
}
